{
  "title": "Jim's Glowing Coin",
  "source": "Acquisitions Inc.",
  "levelAndSchool": "2nd-level enchantment",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S, M (a coin, 2 gold coins, which is consumed as tax for using the spell)",
  "duration": "1 minute",
  "description": [
    "When you cast the spell, you hurl the coin that is the spell's material component to any spot within range. The coin lights up as if under the effect of a light spell. Each creature of your choice that you can see within 30 feet of the coin must succeed on a Wisdom saving throw or be distracted for the duration. While distracted, a creature has disadvantage on Wisdom (Perception) checks and initiative rolls."
  ],
  "spellLists": ["arcane-trickster", "wizard"]
}
